import RewardBadge from './RewardBadge';
export default RewardBadge;